import React from "react";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import useTranslationCandidates from "../useTranslationCandidates.js";
import CandidateProfileInlineEditInputText from "../mutate/CandidateProfileInlineEditInputText.js";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import ApplicationsByCandidateList from "./ApplicationsByCandidateList.js";
import ResumeDownloadLink from "./ResumeDownloadLink.js";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import useQueryApplicationByCandidateRemainingCount from "./useQueryApplicationByCandidateRemainingCount.js";
import WaitForData from "../../common/data-fetching/WaitForData.js";
import ReportProblemOutlined from "@mui/icons-material/ReportProblemOutlined";
import RefreshButton from "../../common/widgets/RefreshButton.js";
import PageSubtitle from "../../common/widgets/PageSubtitle.js";
import InformationDisplay from "../../common/widgets/InformationDisplay.js";
import "./CandidateProfileBlock.scss";

export default function CandidateProfileBlock(props) {
  const { candidate } = props;
  const { t, loading: tLoading } = useTranslationCandidates();
  useShowLoader(tLoading, "ApplicationsList");

  const hasResume = !!candidate.resumeId;

  const {
    data: remainingApplicationsCount,
    loading,
    errors,
  } = useQueryApplicationByCandidateRemainingCount(candidate._id);

  const listTitle = t("candidates:candidates_application_list_title");
  const applicationInfo = t("candidates:candidates_application_list_label", {
    count: remainingApplicationsCount,
  });

  return (
    <div className="CandidateProfileBlock ">
      <Col className="candidate-profile-block ">
        <Row>
          <Col className="name-col">
            <CandidateProfileInlineEditInputText
              candidate={candidate}
              property={"name"}
              placeholder={t(
                "candidates:candidates_update_candidate_name_placeholder"
              )}
            />
          </Col>
          <Col className="refresh-col">
            <RefreshButton />
          </Col>
        </Row>
        <Row>
          <Col>
            <Row>
              <Col className="candidate-contact-col">
                <Row>
                  <Col className="icon-col">
                    <PhoneIcon />
                  </Col>
                  <Col
                    className={candidate.phone ? "phone-col" : "icon-data-col"}
                  >
                    <CandidateProfileInlineEditInputText
                      candidate={candidate}
                      viewAs="span"
                      property={"phone"}
                      placeholder={t(
                        "candidates:candidates_update_candidate_phone_placeholder"
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="icon-col">
                    <EmailIcon />
                  </Col>
                  <Col className="email-col">
                    <CandidateProfileInlineEditInputText
                      candidate={candidate}
                      viewAs="span"
                      property={"email"}
                      placeholder={t(
                        "candidates:candidates_update_candidate_email_placeholder"
                      )}
                    />
                  </Col>
                </Row>
              </Col>
              <Col>
                <Row>
                  <Col className="icon-col">
                    <LinkedInIcon />
                  </Col>
                  <Col
                    className={
                      candidate.linkedin ? "linkedin-col" : "icon-data-col"
                    }
                  >
                    <CandidateProfileInlineEditInputText
                      candidate={candidate}
                      viewAs="span"
                      property={"linkedin"}
                      placeholder={t(
                        "candidates:candidates_update_candidate_linkedin_placeholder"
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="icon-col">
                    <AccountBoxIcon />
                  </Col>
                  <Col
                    className={
                      candidate.indeed ? "indeed-col" : "icon-data-col"
                    }
                  >
                    <CandidateProfileInlineEditInputText
                      candidate={candidate}
                      viewAs="span"
                      property={"indeed"}
                      placeholder={t(
                        "candidates:candidates_update_candidate_indeed_placeholder"
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="icon-col">
                    <CloudDownloadIcon
                      alt={t(
                        "candidates:candidates_details_download_resume_action"
                      )}
                    />
                  </Col>
                  <Col className="download-link-col">
                    <ResumeDownloadLink
                      candidate={candidate}
                      disabled={!hasResume}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className="information-display-col">
            <InformationDisplay
              hoverInformation={t("candidates:candidates_hover_information")}
              information={applicationInfo}
            />
          </Col>
        </Row>
        <Row>
          <Col className="application-list-col">
            <Row>
              <Col>
                <PageSubtitle colTitle={listTitle} />
              </Col>
            </Row>
            <Row className="applications-row">
              <Col>
                <WaitForData
                  loading={loading}
                  errors={errors}
                  onError={() => (
                    <ReportProblemOutlined className="LoadingError" />
                  )}
                  onLoaded={() => (
                    <ApplicationsByCandidateList
                      candidateId={candidate._id}
                      remainingApplicationsCount={remainingApplicationsCount}
                    />
                  )}
                />
              </Col>
            </Row>
            <Row className="applications-row">
              <Col className="indication-col">
                {t(
                  "candidates:candidates_details_application_approval_message"
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </div>
  );
}
